import type { CustomerPropertiesMap } from '../../models/user/User'

export const PERSONIFY_BENEFIT_PARTNER = 'personify'
export const PERSONIFY_SSO_INIT_PATH = '/api/sso/oidc/init/personify'

export const isPersonifyBenefitPartner = (benefitPartner?: CustomerPropertiesMap['benefitPartner']) =>
  (benefitPartner ?? '').trim().toLowerCase() === PERSONIFY_BENEFIT_PARTNER

export const getPersonifySsoUrl = (baseUrl = '') => `${baseUrl.replace(/\/+$/, '')}${PERSONIFY_SSO_INIT_PATH}`
